import React from "react"

import { InputRootProps } from "../Input"

export interface BooleanInputContextType {
  trueLabel?: string
  falseLabel?: string
}
export interface BooleanInputRootProps
  extends InputRootProps,
    BooleanInputContextType {}

export const BooleanInputContext = React.createContext<BooleanInputContextType>(
  {}
)
